import { Component, Inject } from '@angular/core';
import { CodeJarContainer } from 'ngx-codejar';
import hljs from 'highlight.js';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
@Component({
  selector: 'app-modal-css',
  templateUrl: './modal-css.component.html',
  styleUrls: ['./modal-css.component.scss'],
})
export class ModalCssComponent {
  css: string = '';
  constructor(
    public dialogRef: MatDialogRef<ModalCssComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: { data: string }
  ) {
    this.css = data.data;
  }

  closeModal(close: boolean) {
    this.dialogRef.close({ close, css: this.css });
  }
  highlightMethodCss(editor: CodeJarContainer) {
    if (editor.textContent !== null && editor.textContent !== undefined) {
      editor.innerHTML = hljs.highlight(editor.textContent, {
        language: 'css',
      }).value;
    }
  }
}
